import React, { FC } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Form, Formik } from 'formik';
import { Button } from '../Button/Button';
import { InputPanel } from './InputPanel';

interface Props {
  onCancel: () => void;
  onOkay: (text: string) => void;
}

export const BriefDenialDialog: FC<Props> = ({ onCancel, onOkay }) => {
  const handleFormSubmit = async (values: any) => {
    onOkay(values.text);
  };

  return (
    <Dialog open onClose={onCancel}>
      <DialogTitle>
        <Typography variant="h5">
          Approval Denied
        </Typography>
      </DialogTitle>

      <Formik initialValues={{ text: '' }} onSubmit={handleFormSubmit}>
        {({ values }) => (
          <Form>
            <>
              <DialogContent className="flex flex-col gap-6 max-sm:w-full sm:w-[450px]">
                <InputPanel
                  name="text"
                  body="Please share your reason(s) for denying the proposed experts"
                />
              </DialogContent>
              <DialogActions>
                <Box className="flex items-center gap-6 px-4 pb-4">
                  <Button
                    onClick={onCancel}
                    variant="default"
                    className="!bg-surface-2 hover:!bg-track !text-text-1 h-[40px] !py-0 !px-4 !min-w-fit"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    disabled={!values.text}
                    variant="contained"
                    className="h-[40px] !py-0 !px-4 !min-w-fit"
                  >
                    Submit
                  </Button>
                </Box>
              </DialogActions>
            </>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};
